interface PlaybookEntry {
  filename: string
  label: string
}

export const PLAYBOOK_CONFIG: Record<string, PlaybookEntry> = {
  crypto: { filename: 'IVIX_Playbook_Crypto.pdf', label: 'Crypto' },
  smi: { filename: 'IVIX_Playbook_Influencers.pdf', label: 'Influencers' },
  ecommerce: { filename: 'IVIX_Playbook_Ecommerce_Marketplaces.pdf', label: 'Ecommerce Marketplaces' },
  ecommerceSalesTax: {
    filename: 'IVIX_Playbook_Ecommerce_Independent_Sellers.pdf',
    label: 'Ecommerce Independent Sellers',
  },
  gigEconomy: { filename: 'IVIX_Playbook_Freelancers.pdf', label: 'Freelancers' },
  offshore: { filename: 'IVIX_Playbook_Offshore.pdf', label: 'Offshore' },
  companyOverview: { filename: 'IVIX_Playbook_Company_Overview.pdf', label: 'Company Overview' },
  str: { filename: 'IVIX_Playbook_STR.pdf', label: 'Short-Term Rentals' },
}
